import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { FinalSetupNavigationService } from '../services/final-setup-navigation.service';

@Injectable({
  providedIn: 'root',
})
export class FinalSetupNavigationGuard {
  private finalSetupNavigationService = inject(FinalSetupNavigationService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  canActivate(): Observable<boolean> {
    return this.finalSetupNavigationService.canNavigate();
  }
}
